var render = function render(){
  var _vm$insufficientPayme, _vm$insufficientPayme2, _vm$insufficientPayme3, _vm$insufficientPayme4, _vm$insufficientPayme5, _vm$insufficientPayme9, _vm$insufficientPayme10, _vm$insufficientPayme11, _vm$insufficientPayme12, _vm$insufficientPayme13, _vm$insufficientPayme14, _vm$insufficientPayme15, _vm$insufficientPayme16, _vm$insufficientPayme17, _vm$insufficientPayme18, _vm$insufficientPayme19, _vm$insufficientPayme20, _vm$insufficientPayme21, _vm$insufficientPayme22, _vm$insufficientPayme23, _vm$insufficientPayme24, _vm$insufficientPayme25, _vm$insufficientPayme26, _vm$insufficientPayme27, _vm$insufficientPayme28, _vm$insufficientPayme29, _vm$insufficientPayme30, _vm$insufficientPayme31, _vm$insufficientPayme32, _vm$insufficientPayme33, _vm$insufficientPayme34, _vm$insufficientPayme35, _vm$insufficientPayme36, _vm$insufficientPayme37, _vm$insufficientPayme38, _vm$insufficientPayme39, _vm$insufficientPayme40, _vm$insufficientPayme41, _vm$insufficientPayme42, _vm$insufficientPayme43, _vm$insufficientPayme44, _vm$insufficientPayme45, _vm$insufficientPayme46, _vm$insufficientPayme47;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "order text-neutral-500"
  }, [_c('div', {
    staticClass: "bg-white mb-40"
  }, [_c('div', {
    staticClass: "flex gap-3 justify-between p-6 shadow-border-b"
  }, [_c('div', {
    staticClass: "flex gap-3"
  }, [_c('span', {
    staticClass: "flex justify-center items-center px-2 py-1 text-xs rounded-md",
    style: 'backgroundColor: ' + _vm.insufficientPaymentDetail.status_color + '; color: white;'
  }, [_vm._v(_vm._s(_vm.insufficientPaymentDetail.status_display))]), _c('div', [_c('span', {
    staticClass: "text-neutral-500 text-xs block mb-1"
  }, [_vm._v(_vm._s(_vm.insufficientPaymentDetail.created_time_display) + " / " + _vm._s(_vm.insufficientPaymentDetail.order_id))]), _c('p', {
    staticClass: "text-neutral-500 text-xs flex items-center gap-2 mdmax:flex-col mdmax:gap-1 mdmax:items-start"
  }, [_c('span', [_c('strong', [_vm._v("AWB Linknau")]), _vm._v(": " + _vm._s((_vm$insufficientPayme = _vm.insufficientPaymentDetail.order_delivery) === null || _vm$insufficientPayme === void 0 ? void 0 : _vm$insufficientPayme.awb))]), (_vm$insufficientPayme2 = _vm.insufficientPaymentDetail.order_delivery) !== null && _vm$insufficientPayme2 !== void 0 && _vm$insufficientPayme2.external_awb ? [_c('span', {
    staticClass: "mdmax:hidden"
  }, [_vm._v("|")]), _vm._v(" "), _c('span', [_c('strong', [_vm._v("AWB Mitra")]), _vm._v(": " + _vm._s((_vm$insufficientPayme3 = _vm.insufficientPaymentDetail.order_delivery) === null || _vm$insufficientPayme3 === void 0 ? void 0 : _vm$insufficientPayme3.external_awb))])] : _vm._e()], 2)])]), _vm.isConfirmButtonVisible ? _c('div', {}, [_c('Button', {
    attrs: {
      "buttonText": "Konfirmasi"
    },
    on: {
      "action": function ($event) {
        return _vm.toggleConfirmModal();
      }
    }
  })], 1) : _vm._e()]), _c('div', {
    staticClass: "flex mdmax:flex-col"
  }, [_c('div', {
    staticClass: "flex-1"
  }, [_c('div', {
    staticClass: "p-6 shadow-border-b"
  }, [_c('p', {
    staticClass: "text-xl font-bold mb-6 text-neutral-700"
  }, [_vm._v("Berat dan Jenis Paket")]), _vm._l((_vm$insufficientPayme4 = _vm.insufficientPaymentDetail) === null || _vm$insufficientPayme4 === void 0 ? void 0 : (_vm$insufficientPayme5 = _vm$insufficientPayme4.order_delivery) === null || _vm$insufficientPayme5 === void 0 ? void 0 : _vm$insufficientPayme5.packages, function (packageItem, index) {
    var _vm$insufficientPayme6, _vm$insufficientPayme7, _vm$insufficientPayme8;

    return _c('div', {
      key: 'package-' + index,
      staticClass: "flex justify-start gap-6 mb-4 border rounded-md px-3 py-2 bg-neutral-200 last:mb-0"
    }, [_c('div', {
      staticClass: "flex-1"
    }, [_c('p', {
      staticClass: "text-sm font-medium mb-1 text-neutral-700"
    }, [_vm._v("Berat Barang")]), _c('p', [_vm._v(_vm._s(packageItem.weight) + "kg")])]), _c('div', {
      staticClass: "flex-1"
    }, [_c('p', {
      staticClass: "text-sm font-medium mb-1 text-neutral-700"
    }, [_vm._v("Jenis Paket")]), _c('p', [_vm._v(_vm._s(packageItem.category))])]), _c('div', {
      staticClass: "flex-1"
    }, [_c('p', {
      staticClass: "text-sm font-medium mb-1 text-neutral-700"
    }, [_vm._v("Kurang Bayar")]), _c('p', [_vm._v(_vm._s(_vm._f("currencyFormat")((_vm$insufficientPayme6 = _vm.insufficientPaymentDetail) === null || _vm$insufficientPayme6 === void 0 ? void 0 : (_vm$insufficientPayme7 = _vm$insufficientPayme6.order_delivery) === null || _vm$insufficientPayme7 === void 0 ? void 0 : (_vm$insufficientPayme8 = _vm$insufficientPayme7.additional_package_charge) === null || _vm$insufficientPayme8 === void 0 ? void 0 : _vm$insufficientPayme8.add_cost)))])])]);
  })], 2), _c('div', {
    staticClass: "p-6 shadow-border-b"
  }, [_c('p', {
    staticClass: "text-xl font-bold mb-6 text-neutral-700"
  }, [_vm._v("Layanan")]), _c('div', {
    staticClass: "flex items-center"
  }, [_c('div', {
    staticClass: "w-2/5"
  }, [_c('p', {
    staticClass: "text-sm font-medium mb-1 text-neutral-700"
  }, [_vm._v("Nama Layanan")]), _c('p', [_vm._v(_vm._s(((_vm$insufficientPayme9 = _vm.insufficientPaymentDetail.order_delivery) === null || _vm$insufficientPayme9 === void 0 ? void 0 : _vm$insufficientPayme9.service_package_name) || '-'))])]), _c('div', {
    staticClass: "w-3/5"
  }, [_c('p', {
    staticClass: "text-sm font-medium mb-1 text-neutral-700"
  }, [_vm._v("Tipe Layanan")]), _c('p', [_vm._v(_vm._s(_vm.getServiceType((_vm$insufficientPayme10 = _vm.insufficientPaymentDetail.order_delivery) === null || _vm$insufficientPayme10 === void 0 ? void 0 : _vm$insufficientPayme10.service_type) || '-'))])])])]), _c('div', {
    staticClass: "p-6"
  }, [_c('p', {
    staticClass: "text-xl font-bold mb-6 text-neutral-700"
  }, [_vm._v("Info Pengiriman")]), _c('div', {
    staticClass: "flex justify-start gap-6 mb-6"
  }, [_c('div', {
    staticClass: "w-2/5"
  }, [_c('p', {
    staticClass: "text-sm font-medium mb-1 text-neutral-700"
  }, [_vm._v("Nama Pengirim")]), _c('p', [_vm._v(_vm._s(((_vm$insufficientPayme11 = _vm.insufficientPaymentDetail) === null || _vm$insufficientPayme11 === void 0 ? void 0 : (_vm$insufficientPayme12 = _vm$insufficientPayme11.order_delivery) === null || _vm$insufficientPayme12 === void 0 ? void 0 : (_vm$insufficientPayme13 = _vm$insufficientPayme12.sender) === null || _vm$insufficientPayme13 === void 0 ? void 0 : _vm$insufficientPayme13.name) || '-'))])]), _c('div', {
    staticClass: "w-3/5"
  }, [_c('p', {
    staticClass: "text-sm font-medium mb-1 text-neutral-700"
  }, [_vm._v("No. HP Pengirim")]), _c('p', [_vm._v(_vm._s(((_vm$insufficientPayme14 = _vm.insufficientPaymentDetail) === null || _vm$insufficientPayme14 === void 0 ? void 0 : (_vm$insufficientPayme15 = _vm$insufficientPayme14.order_delivery) === null || _vm$insufficientPayme15 === void 0 ? void 0 : (_vm$insufficientPayme16 = _vm$insufficientPayme15.sender) === null || _vm$insufficientPayme16 === void 0 ? void 0 : _vm$insufficientPayme16.phone_number) || '-'))])])]), _c('p', {
    staticClass: "text-sm font-medium mb-1 text-neutral-700"
  }, [_vm._v("Alamat Pengirim")]), _c('p', [_vm._v(_vm._s(((_vm$insufficientPayme17 = _vm.insufficientPaymentDetail) === null || _vm$insufficientPayme17 === void 0 ? void 0 : (_vm$insufficientPayme18 = _vm$insufficientPayme17.order_delivery) === null || _vm$insufficientPayme18 === void 0 ? void 0 : (_vm$insufficientPayme19 = _vm$insufficientPayme18.sender) === null || _vm$insufficientPayme19 === void 0 ? void 0 : _vm$insufficientPayme19.address) || '-'))]), _c('div', {
    staticClass: "mt-6 p-2 bg-neutral-200 rounded-md"
  }, [_c('p', {
    staticClass: "text-sm font-medium mb-1 text-neutral-700"
  }, [_vm._v("Detail Pickup")]), _c('p', [_vm._v(_vm._s(((_vm$insufficientPayme20 = _vm.insufficientPaymentDetail) === null || _vm$insufficientPayme20 === void 0 ? void 0 : (_vm$insufficientPayme21 = _vm$insufficientPayme20.order_delivery) === null || _vm$insufficientPayme21 === void 0 ? void 0 : (_vm$insufficientPayme22 = _vm$insufficientPayme21.sender) === null || _vm$insufficientPayme22 === void 0 ? void 0 : _vm$insufficientPayme22.detail_address) || '-'))])])]), _c('div', {
    staticClass: "p-6 mdmax:shadow-border-b"
  }, [_c('p', {
    staticClass: "text-xl font-bold mb-6 text-neutral-700"
  }, [_vm._v("Info Penerima")]), _c('div', {
    staticClass: "flex justify-start gap-6 mb-6"
  }, [_c('div', {
    staticClass: "w-2/5"
  }, [_c('p', {
    staticClass: "text-sm font-medium mb-1 text-neutral-700"
  }, [_vm._v("Nama Penerima")]), _c('p', [_vm._v(_vm._s(((_vm$insufficientPayme23 = _vm.insufficientPaymentDetail) === null || _vm$insufficientPayme23 === void 0 ? void 0 : (_vm$insufficientPayme24 = _vm$insufficientPayme23.order_delivery) === null || _vm$insufficientPayme24 === void 0 ? void 0 : (_vm$insufficientPayme25 = _vm$insufficientPayme24.receiver) === null || _vm$insufficientPayme25 === void 0 ? void 0 : _vm$insufficientPayme25.name) || '-'))])]), _c('div', {
    staticClass: "w-3/5"
  }, [_c('p', {
    staticClass: "text-sm font-medium mb-1 text-neutral-700"
  }, [_vm._v("No. HP Penerima")]), _c('p', [_vm._v(_vm._s(((_vm$insufficientPayme26 = _vm.insufficientPaymentDetail) === null || _vm$insufficientPayme26 === void 0 ? void 0 : (_vm$insufficientPayme27 = _vm$insufficientPayme26.order_delivery) === null || _vm$insufficientPayme27 === void 0 ? void 0 : (_vm$insufficientPayme28 = _vm$insufficientPayme27.receiver) === null || _vm$insufficientPayme28 === void 0 ? void 0 : _vm$insufficientPayme28.phone_number) || '-'))])])]), _c('p', {
    staticClass: "text-sm font-medium mb-1 text-neutral-700"
  }, [_vm._v("Alamat Penerima")]), _c('p', [_vm._v(_vm._s(((_vm$insufficientPayme29 = _vm.insufficientPaymentDetail) === null || _vm$insufficientPayme29 === void 0 ? void 0 : (_vm$insufficientPayme30 = _vm$insufficientPayme29.order_delivery) === null || _vm$insufficientPayme30 === void 0 ? void 0 : (_vm$insufficientPayme31 = _vm$insufficientPayme30.receiver) === null || _vm$insufficientPayme31 === void 0 ? void 0 : _vm$insufficientPayme31.address) || '-'))]), _c('div', {
    staticClass: "mt-6 p-2 bg-neutral-200 rounded-md"
  }, [_c('p', {
    staticClass: "text-sm font-medium mb-1 text-neutral-700"
  }, [_vm._v("Detail Pickup")]), _c('p', [_vm._v(_vm._s(((_vm$insufficientPayme32 = _vm.insufficientPaymentDetail) === null || _vm$insufficientPayme32 === void 0 ? void 0 : (_vm$insufficientPayme33 = _vm$insufficientPayme32.order_delivery) === null || _vm$insufficientPayme33 === void 0 ? void 0 : (_vm$insufficientPayme34 = _vm$insufficientPayme33.receiver) === null || _vm$insufficientPayme34 === void 0 ? void 0 : _vm$insufficientPayme34.detail_address) || '-'))])])])]), _c('div', {
    staticClass: "flex-1 shadow-border-l mdmax:shadow-none"
  }, [_c('div', {
    staticClass: "p-6 shadow-border-b"
  }, [_c('p', {
    staticClass: "text-xl font-bold mb-6 text-neutral-700"
  }, [_vm._v("Foto Barang")]), (_vm$insufficientPayme35 = _vm.insufficientPaymentDetail) !== null && _vm$insufficientPayme35 !== void 0 && (_vm$insufficientPayme36 = _vm$insufficientPayme35.order_delivery) !== null && _vm$insufficientPayme36 !== void 0 && _vm$insufficientPayme36.goods_picture_url ? [_c('img', {
    attrs: {
      "src": (_vm$insufficientPayme37 = _vm.insufficientPaymentDetail) === null || _vm$insufficientPayme37 === void 0 ? void 0 : (_vm$insufficientPayme38 = _vm$insufficientPayme37.order_delivery) === null || _vm$insufficientPayme38 === void 0 ? void 0 : _vm$insufficientPayme38.goods_picture_url
    }
  })] : _c('p', [_vm._v("- Foto tidak tersedia -")])], 2), _c('div', {
    staticClass: "p-6 shadow-border-b"
  }, [_c('p', {
    staticClass: "text-xl font-bold mb-6 text-neutral-700"
  }, [_vm._v("Informasi Pembayaran")]), _c('div', {
    staticClass: "mb-6"
  }, [_c('p', {
    staticClass: "text-sm font-medium mb-1 text-neutral-700"
  }, [_vm._v("Status")]), _c('p', [_vm._v(_vm._s(((_vm$insufficientPayme39 = _vm.insufficientPaymentDetail) === null || _vm$insufficientPayme39 === void 0 ? void 0 : (_vm$insufficientPayme40 = _vm$insufficientPayme39.payment_info) === null || _vm$insufficientPayme40 === void 0 ? void 0 : _vm$insufficientPayme40.status) || '-'))])]), _c('div', {
    staticClass: "flex justify-start gap-6 mb-6"
  }, [_c('div', {
    staticClass: "w-2/5"
  }, [_c('p', {
    staticClass: "text-sm font-medium mb-1 text-neutral-700"
  }, [_vm._v("Tipe Pembayaran")]), _c('p', [_vm._v(_vm._s(((_vm$insufficientPayme41 = _vm.insufficientPaymentDetail) === null || _vm$insufficientPayme41 === void 0 ? void 0 : (_vm$insufficientPayme42 = _vm$insufficientPayme41.payment_info) === null || _vm$insufficientPayme42 === void 0 ? void 0 : _vm$insufficientPayme42.payment_method) || '-'))])]), _c('div', {
    staticClass: "w-3/5"
  }, [_c('p', {
    staticClass: "text-sm font-medium mb-1 text-neutral-700"
  }, [_vm._v("Bank")]), _c('p', [_vm._v(_vm._s(((_vm$insufficientPayme43 = _vm.insufficientPaymentDetail) === null || _vm$insufficientPayme43 === void 0 ? void 0 : (_vm$insufficientPayme44 = _vm$insufficientPayme43.payment_info) === null || _vm$insufficientPayme44 === void 0 ? void 0 : _vm$insufficientPayme44.payment_provider) || '-'))])])]), _c('div', {
    staticClass: "flex justify-start gap-6 mb-6"
  }, [_c('div', {
    staticClass: "w-2/5"
  }, [_c('p', {
    staticClass: "text-sm font-medium mb-1 text-neutral-700"
  }, [_vm._v("No Rekening")]), _c('p', [_vm._v(_vm._s(((_vm$insufficientPayme45 = _vm.insufficientPaymentDetail) === null || _vm$insufficientPayme45 === void 0 ? void 0 : (_vm$insufficientPayme46 = _vm$insufficientPayme45.payment_info) === null || _vm$insufficientPayme46 === void 0 ? void 0 : _vm$insufficientPayme46.payment_account_display) || '-'))])])])]), _c('div', {
    staticClass: "p-6"
  }, [_c('p', {
    staticClass: "text-xl font-bold mb-6 text-neutral-700"
  }, [_vm._v("Status Pengiriman")]), _vm._l((_vm$insufficientPayme47 = _vm.insufficientPaymentDetail) === null || _vm$insufficientPayme47 === void 0 ? void 0 : _vm$insufficientPayme47.tracking_infos, function (tracking, index) {
    return _c('div', {
      key: 'tracking' + index,
      staticClass: "flex gap-5"
    }, [_c('div', {
      staticClass: "line relative"
    }, [_c('span', {
      staticClass: "inline-block w-5 h-5 rounded-full border-4 relative z-1",
      class: index === 0 ? 'bg-primary-500 border-primary-100' : 'bg-neutral-500 border-neutral-300'
    }), _c('span', {
      staticClass: "absolute border-dashed border-neutral-300 h-full w-px border left-1/2 transform -translate-x-1/2 top-0 z-0"
    })]), _c('div', {
      staticClass: "status mb-6"
    }, [_c('p', {
      staticClass: "text-sm mb-1"
    }, [_vm._v(_vm._s(tracking.time_display))]), _c('p', {
      staticClass: "text-neutral-700 mb-1"
    }, [_vm._v(_vm._s(tracking.main_info))]), _c('p', {
      staticClass: "text-sm"
    }, [_vm._v(_vm._s(tracking.additional_info))])])]);
  })], 2)])]), _vm.insufficientPaymentDetail.is_require_hubcek ? _c('div', {
    staticClass: "text-xs p-4 flex items-center gap-2 bg-secondary-100 text-neutral-700"
  }, [_c('Info', {
    attrs: {
      "width": "24",
      "height": "24",
      "color": "neutral-700"
    }
  }), _vm._v("Jangan lupa periksa kembali barang yang telah diterima sebelum memindahkan status order, pastikan sesuai dengan ukuran yang telah ditetapkan. ")], 1) : _vm._e()]), _c('Modal', {
    attrs: {
      "modalVisible": _vm.visibleConfirmModal,
      "width": "600px",
      "id": "confirmation-modal"
    },
    on: {
      "close": function ($event) {
        return _vm.toggleConfirmModal();
      }
    }
  }, [_c('template', {
    slot: "modal-content"
  }, [_c('div', {
    staticClass: "p-1"
  }, [_c('div', {
    staticClass: "flex items-start justify-start gap-6 mb-6"
  }, [_c('span', {
    staticClass: "flex-shrink-0"
  }, [_c('Alert', {
    attrs: {
      "color": "neutral-700"
    }
  })], 1), _c('div', {
    staticClass: "flex-col flex gap-2 items-start"
  }, [_c('p', {
    staticClass: "text-2xl font-bold"
  }, [_vm._v("Konfirmasi")]), _c('p', {
    staticClass: "text-sm text-neutral-500 text-left"
  }, [_vm._v(" Pastikan Anda telah yakin untuk melakukan proses konfirmasi / perubahan status ini. ")]), _c('div', {
    staticClass: "w-full text-left mt-6"
  }, [_c('TextField', {
    attrs: {
      "label": "Kode Transaksi",
      "placeholder": "Masukkan kode transaksi"
    },
    model: {
      value: _vm.referenceId,
      callback: function ($$v) {
        _vm.referenceId = $$v;
      },
      expression: "referenceId"
    }
  })], 1)])]), _c('div', {
    staticClass: "flex justify-end gap-4"
  }, [_c('Button', {
    attrs: {
      "buttonText": "Batal",
      "type": "secondary",
      "size": _vm.isMobile ? 'full' : 'regular'
    },
    on: {
      "action": function ($event) {
        return _vm.toggleConfirmModal();
      }
    }
  }), _c('Button', {
    attrs: {
      "buttonText": "Konfirmasi",
      "disabled": !_vm.referenceId,
      "type": "primary",
      "size": _vm.isMobile ? 'full' : 'regular'
    },
    on: {
      "action": function ($event) {
        return _vm.confirmation();
      }
    }
  })], 1)])])], 2)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }